<template>
    <div class="about">
      <Header 
        title="Conecte com o Discord" 
        subtitle="Para participar de nossos mix"
      ></Header>
      <div class="container">

        <p>Para participar de nossos mix no discord, você precisa:</p>

        <div v-if="!this.isLoggedIn">
          <p>Logar no queota.club</p>
          <a
            class="btn btn-block btn-lg btn-dark"
            :href="`${isLocal ? 'https://api.queota.club' : 'http://localhost:5000'}/steamconnect`"
          >
            <i class="fab fa-steam"></i>
            Entre agora com sua Steam
          </a>
        </div>
        <div v-else>
          <p class="text-success">Logar no queota.club ✅</p>
        </div>

        <div v-if="!this.isLoggedIn">
          <p>Conectar com o discord</p>
        </div>
        <div v-else-if="!this.isDiscordConnected">
          <p class="text-danger">Conectar com o discord ❌</p>

          <div class="discord-connect-button">
            <a
              class="btn btn-block btn-lg btn-primary"
              :href="`${isLocal ? 'https://api.queota.club' : 'http://localhost:5000'}/auth/discord`"
            >
              <i class="fab fa-discord"></i>
              Entre agora com seu Discord
            </a>
          </div>
        </div>
        <div v-else>
          <p class="text-success">Conectar com o discord ✅</p>
        </div>

        <p>
        Aí é voltar para o discord e pode participar de nossos mix!
        </p>
  
      </div>
    </div>
  </template>
  
  <script>
  import Header from '@/components/Header'
  export default {
    name: 'Discord',
    metaInfo: {
      title: 'Discord'
    },
    computed: {
      isLocal: function() {
        return window.location.hostname == "queota.club";
      },
      isDiscordConnected: function() {
        return this.$store.getters.user.discord_id;
      }
    },
    data () {
      return {
        servers: null
      }
    },
    methods: {
    //   initialize() {
    //     this.$http
    //       .get('pug_servers.json')
    //       .then(response => (this.servers = response.data))
        
    //   }
    },
    mounted () {
    //   this.initialize()
      if(this.$route.query.discord_connected) {
        this.$http.get("pages/my_account.json").then(response => {
          this.$store.dispatch('updateUserProfile', response.data)
        });
        // Discord connected
        // alert('Discord connected')
      }

      if(this.$route.query.discord_error) {
        alert('Erro ao conectar com o Discord, por favor, deslogue do queota.club e refaça o processo pelo discord')
      }
    },
    components: {
      Header
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .server-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .gs-widget {
      width: 49%;
    }
  }
  
  .gs-widget {
    display: block;
    background: #333333;
    padding: 20px 20px;
    color: rgba(255, 255, 255, .5);
    filter: contrast(130%);
    transition: all .1s;
    &:hover {
      filter: contrast(160%);
      text-decoration: none;
    }
  
    span.icon {
      font-size: 13px;
    }
  
    &:not(:last-child) {
      margin-bottom: 6px;
    }
  
    p {
      margin: 0 !important;
      padding: 0 !important;
      &.hostname {
        font-weight: bold;
      }
      &.map {}
      &.players {
        font-weight: bold;
        color: white;
      }
    }
  }
  </style>
  